{{dotMode ? '' : text}}